import store from '@/store'
import session from '@/auth/session'
import users from '@/api/apiUsersManagement/services/users'

/**
 * Set User
 * @param {Object} payload - User Object.
 */
export const set = ({ commit, dispatch, state, getters }, payload) => {
  return new Promise((resolve, reject) => {
    commit('SET_ID', payload.id)
    commit('SET_USERNAME', payload.username)
    commit('SET_PASSWORD', payload.password)
    commit('SET_EMAIL', payload.email)
    commit('SET_ROLE', payload.role)
    resolve()
  })
}

/**
 * Get User details
 * @param {Object} payload - User basic info (id) object.
 */
export const get = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    if (!payload || !payload.id) {
      reject(new Error('Wrong selection'))
      return
    }
    let {
      id
    } = payload
    let user = store.getters['users/list/getItemById'](id)
    dispatch('set', user).then(user => resolve(user))
  })
}

export const create = ({ getters }) => {
  return new Promise((resolve, reject) => {
    let user = getters.apificate
    if (user.id) delete user.id
    users.create(session.getUserId(), user)
    .then((res) => {
      resolve(user)
    })
  })
}

/**
 * Update User
 * @param {Object} payload - User Object.
 */
export const update = ({ getters }, payload) => {
  return new Promise((resolve, reject) => {
    if (!payload || !payload.id) reject(new Error('Wrong update info'))
    let {
      id
    } = payload
    let user = getters.apificate
    users.update(id, user)
    .then((res) => {
      resolve(user)
    })
  })
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_ID', undefined)
    commit('SET_USERNAME', undefined)
    commit('SET_PASSWORD', undefined)
    commit('SET_EMAIL', undefined)
    commit('SET_ROLE', undefined)
    resolve()
  })
}

export const loading = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', false)
    resolve(false)
  })
}

export const loaded = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', true)
    resolve(true)
  })
}
